module.exports = __webpack_public_path__ + "img/remove.72daca21.svg";